export function formatDuration(totalSeconds: number | null | undefined): string {
  if (totalSeconds === null || totalSeconds === undefined) return "-";
  const seconds = Math.round(totalSeconds);
  const minutes = Math.floor(seconds / 60);
  const remSeconds = seconds % 60;
  const hours = Math.floor(minutes / 60);
  const remMinutes = minutes % 60;
  if (hours) {
    return `${hours}h ${String(remMinutes).padStart(2, "0")}m ${String(remSeconds).padStart(2, "0")}s`;
  }
  return `${remMinutes}m ${String(remSeconds).padStart(2, "0")}s`;
}

export function formatMetric(
  value: number | null | undefined,
  digits = 2,
  suffix = "",
): string {
  if (value === null || value === undefined) return "-";
  return `${value.toFixed(digits)}${suffix}`;
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return "-";
  try {
    return new Date(value).toUTCString();
  } catch {
    return value;
  }
}
